export default function createTransform(Collection, controller) {
  return (state, opts) => {
    if (state === undefined || state.data instanceof Collection === false) {
      return state;
    }
    if (Array.isArray(controller.implements)) {
      return controller.implements.reduce(
        (acc, next) => acc.merge(next.call(this, acc, opts)),
        state
      );
    }
    return state;
  };
}
